import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export enum STATE {
  IDLE = 0,
  UPLOADING = 1,
  // eslint-disable-next-line no-magic-numbers
  UPDATING = 2,
  // eslint-disable-next-line no-magic-numbers
  SUCCESS = 3,
  // eslint-disable-next-line no-magic-numbers
  FAIL = 4
}

export enum TASK_STATUS {
  UPLOAD_SUCCESS = 0,
  GET_SAMPLE_SUCCESS = 1,
  // eslint-disable-next-line no-magic-numbers
  BUILD_SUCCESS = 2,
  // eslint-disable-next-line no-magic-numbers
  BUILD_FAIL = 3
}

export const ERROR_MESSAGE = {
  4841002: '非法授权文件',
  4841003: '非法授权访问',
  4841004: '授权 KEY 错误',
  4841005: '今天的同步次数已用完',
  4841006: '授权文件已过期，请提交最新的授权文件'
}

export interface TaskStatus {
  /** 加密后的key */
  key: string
  /** 状态：0-上传成功，1-获取样本成功，2-生成加密样本数据 3-生成失败 */
  status: number
  /** 样本文件下载地址 */
  file_path: string
}

export interface CheckUploadRes {
  access_id: string
  host: string
  expire: number
  signature: string
  policy: string
  directory: string
}

@Injectable()
export class CloudLibraryUpdateService {
  constructor (private http: Http) {
  }

  generateUUID () {
    if (typeof crypto === 'object') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (typeof crypto.randomUUID === 'function') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return crypto.randomUUID()
      }
      if (typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
        const callback = (c: any) => {
          const num = Number(c)
          // eslint-disable-next-line no-magic-numbers
          return (num ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))).toString(16)
        }
        return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, callback)
      }
    }
    let timestamp = new Date().getTime()
    // eslint-disable-next-line no-magic-numbers
    let perforNow = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-magic-numbers
      let random = Math.random() * 16
      if (timestamp > 0) {
        // eslint-disable-next-line no-magic-numbers
        random = (timestamp + random) % 16 | 0
        // eslint-disable-next-line no-magic-numbers
        timestamp = Math.floor(timestamp / 16)
      } else {
        // eslint-disable-next-line no-magic-numbers
        random = (perforNow + random) % 16 | 0
        // eslint-disable-next-line no-magic-numbers
        perforNow = Math.floor(perforNow / 16)
      }
      // eslint-disable-next-line no-magic-numbers
      return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
    })
  }

  checkToken (data: { token: string }) {
    return this.http.post('/privatizationauth/check/token', data, {
      headers: {
        'X-Cf-TeamID': -1
      }
    })
  }

  checkUpload (data: { token: string }) {
    return this.http.post<CheckUploadRes>('/privatizationauth/check/upload', data, {
      headers: {
        'X-Cf-TeamID': -1
      }
    })
  }

  licenceFileUpload (url: string, data: any, uploadProgressFunction: (progress: any) => void) {
    return this.http.postForm<{ key: string, status: number }>(url, data, uploadProgressFunction)
  }

  uploadSave (data: { token: string, file_name: string }) {
    return this.http.post('/privatizationauth/upload/save', data, {
      headers: {
        'X-Cf-TeamID': -1
      }
    })
  }

  getLibraryStatus (data: { key: string }) {
    return this.http.post<TaskStatus>('/privatizationauth/get/sample', data, {
      headers: {
        'X-Cf-TeamID': -1
      }
    })
  }
}
